/**
  引入axios
 */
  import Axios from 'axios';
  import { Toast } from 'vant';
  import NProgress from 'nprogress';//ajax请求进度条
  import 'nprogress/nprogress.css'
  
  Toast.allowMultiple();//允许同时存在多个Toast
  
  // 添加请求拦截器
  Axios.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
    // console.log('axios请求前',config);
    NProgress.start();//加载进度条开始
    return config;
  }, function (error) {
    NProgress.done();//加载进度条完成
    // 对请求错误做些什么
    Toast.fail('发生一个错误');
    return Promise.reject(error);
  });
  
  // 添加响应拦截器
  Axios.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    // console.log('axios响应前',response);
    NProgress.done();//加载进度条完成
    return response;
  }, function (error) {
    NProgress.done();//加载进度条完成
    // 对响应错误做点什么
    Toast.fail('发生一个错误');
    return Promise.reject(error);
  });
  
  //判断当前设备系统
  var u = navigator.userAgent;
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  var isWeixin = u.toLowerCase().match(/MicroMessenger/i) == "micromessenger";//微信浏览器
  var mobile = u.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  // function isPhone() {
  //   let mobile = u.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  //   return mobile!= null
  // }
  
  var os = '';
  if(isiOS){
      os = 'iOS';
  }
  if(isAndroid){
      os = 'android';
  }
  export default{
    isPhone:mobile,
    ym:'https://mh5.shengu999.com/',
    os:os,
    //截取url后面的参数
    getQueryString:function(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    /**axios */
    $axios:function(src,data,funName){
      console.log(src+'--> ',data);
      var axiosLoading = Toast.loading({
        duration:0,
        message:'加载中'
      });
      const _data = {
        'appId':'youqu',
        'from':'h5',
        'os':os,
      }
      const Data = Object.assign(_data,data);
      Axios({
        method:'post',
        url:'https://cc.shengu999.com/'+src,
        data:Data,
        headers:{
          'Authorization':this.getQueryString('accessToken')
        }
      })
      .then((res)=>{
        axiosLoading.clear();
        console.log(src+'<-- ',res);
        if(res.data.code == 200){
          funName(res.data);
        }else if(res.data.memo){
          if(res.data.code != 600){
            Toast.fail(res.data.memo);
          }
        }else{
          Toast.fail(res.status);
        }
        //余额不足
        if(res.data.code == 600){
          funName(res.data);
        }
      })
      .catch((error)=>{
        axiosLoading.clear();
        console.log('error',error);
      })
    },
    /**客户端交互函数 */
    talk:function(type_text,fun_name,params_list,this_url){
      if(params_list != ''){
        params_list = JSON.stringify(params_list);
        params_list = encodeURIComponent(params_list);
      }
      var Otalk = {};
      Otalk.type = type_text;
      Otalk.fun = fun_name;
      Otalk.params = params_list;
      Otalk.url = this_url;
      console.log('客户端交互+++',Otalk,decodeURIComponent(Otalk.params));
      Otalk = JSON.stringify(Otalk);
      Otalk = encodeURI(Otalk);
      if(isiOS && !isWeixin && window.webkit){
        window.webkit.messageHandlers.nativeFun.postMessage(Otalk);//调用	IOS
      }
      if(isAndroid && !isWeixin && window.Android){
        window.Android.nativeFun(Otalk);//调用	Android
      }
    },
    /**头像增加处理参数 */
    cutAvatar:function(src) {
        if(src.indexOf("shengu999") != -1){
            src = src + '?imageView2/1/w/100/h/100/q/100!/format/gif';
            return src;
        }else{
            return src;
        }
    },
    /**数字转为k */
    kFormatter:function(num) {
        return num > 999 ? (num/1000).toFixed(1) + 'k' : num
    },
    /**截取字符串 */
    cutStr:function(str,long) {
        if(str.length > long){
            return str.substr(0,long) + '...';
        }else{
            return str;
        }
    },
    /**基础信息拼接 */
    infoStr:function(age,city,home){
      var str = '';
  
      const _list = [];
      _list.push(age);
      _list.push(city);
      _list.push(home);
      if(_list.length > 1){
        for(const i in _list){
          if(i < _list.length-1 && _list[i] != ''){
            _list[i] = _list[i] + '｜';
          }
          str = str + _list[i];
        }
      }
      return str;
    },
    /**计算小时分*/
    timeCut:function(msd) {
      var time = parseFloat(msd);
      if (null!= time && ""!= time) {
          if (time > 60  && time < 60*60) {
              time = parseInt(time / 60.0) +"<span>分</span>"
              // + parseInt((parseFloat(time /60.0) - parseInt(time /60.0)) *60) +"<span>秒</span>";
          }else if (time >=60*60 && time <60*60*24) {
              time = parseInt(time /3600.0) +"<span>小时</span>"+ parseInt((parseFloat(time /3600.0) -
                  parseInt(time /3600.0)) *60) +"<span>分</span>"
              // + parseInt((parseFloat((parseFloat(time /3600.0) - parseInt(time /3600.0)) *60) -
              // parseInt((parseFloat(time /3600.0) - parseInt(time /3600.0)) *60)) *60) +"<span>秒</span>";
          }else {
              time = parseInt(time) +"<span>秒</span>";
          }
      }else{
          time = "0<span>时</span>0<span>分</span>";
      }
      return time;
    },
    //时间戳转换为时间格式
    cutTime:function(str){
      function getzf(num){
        if(parseInt(num) < 10){
          num = '0'+num;
        }
        return num;
      }
      var oDate = new Date(str),
        oYear = oDate.getFullYear(),
        oMonth = oDate.getMonth()+1,
        oDay = oDate.getDate(),
        oHour = oDate.getHours(),
        oMin = oDate.getMinutes(),
        oSen = oDate.getSeconds(),
        //      oTime = oYear +'-'+ getzf(oMonth) +'-'+ getzf(oDay) +' '+ getzf(oHour) +':'+ getzf(oMin) +':'+getzf(oSen);//最后拼接时间
        oTime = oYear +'.' + getzf(oMonth) +'.'+ getzf(oDay);//最后拼接时间
      return oTime;
    },
    //url重定向
    loadUrl:function(type,url,str){
      const _url = url + '?v=' + (Math.random()*1000000) + '&accessToken=' + this.getQueryString('accessToken') + str;
      if(type === 'URL'){
        var para = {};
        para.iosRoute = 'SXYouQu://page?VC=BaseWebVC&html=' + encodeURIComponent(_url);
        para.androidRoute = 'arouter://social/activity/common_web?url=' + _url;
        this.talk('route','',para,'');
      }
      if(type === 'url'){
        window.location.href = _url;
      }
    }
  }